export const { REACT_APP_API_HOST_URL: API_HOST_URL, REACT_APP_ESB_API_HOST_URL: API_ESB_HOST_URL } = process.env;
export const API_SERVICE_URL = `${API_HOST_URL}/service`;
export const API_ESB_URL = `${API_ESB_HOST_URL}/esb/api`;
export const MAP_CHANNEL = `efteling-website-generic`;
export const LANGUAGES = ['nl', 'en', 'fr', 'de'];

export const DATE_FORMAT = 'yyyy-MM-dd';
export const SEASON_COLOR = {
    summer: '#112A0A',
    winter: '#03132C',
};
export const DOCUMENT_LANG = document.documentElement.lang;
